import React, { useReducer, useCallback, useMemo, useEffect } from "react";
import { Modal } from "antd";
import Style from "./MapModal.module.css";
import Mapir from "mapir-react-component";
import { errorToast } from "../../../../Toast/Toast";

// Move initial state outside component to prevent recreation
const initialState = {
  center: [53.54347, 36.69056],
  zoom: [12],
  suggestions: [],
  searchQuery: "",
  markerEnd: null,
  addressCompactState: "",
  selectedLocation: null,
  mapKey: Date.now(),
};

// Memoize the reducer to prevent recreation
function mapReducer(state, action) {
  switch (action.type) {
    case "SET_CENTER":
      return { ...state, center: action.payload };
    case "SET_ZOOM":
      return { ...state, zoom: action.payload };
    case "SET_SUGGESTIONS":
      return { ...state, suggestions: action.payload };
    case "SET_SEARCH_QUERY":
      return { ...state, searchQuery: action.payload };
    case "SET_MARKER_END":
      return { ...state, markerEnd: action.payload };
    case "SET_ADDRESS_COMPACT":
      return { ...state, addressCompactState: action.payload };
    case "SET_SELECTED_LOCATION":
      return { ...state, selectedLocation: action.payload };
    case "RESET_SEARCH":
      return { ...state, searchQuery: "", suggestions: [] };
    case "REFRESH_MAP":
      return { ...state, mapKey: Date.now() }; // Update key to force re-render
    default:
      return state;
  }
}

const MapModal = ({
  DeliverState,
  onSelectLocation,
  closeModal,
}) => {
  const [state, dispatch] = useReducer(mapReducer, initialState);

  useEffect(() => {
    setTimeout(() => {
      dispatch({ type: "REFRESH_MAP" })
  }, 500);
  }, [DeliverState.showModal]);
  useEffect(()=>{
    if (DeliverState.currentField === "origin"&&DeliverState.origin) {
      handelReloadOnSaveMap(DeliverState.origin)
    } else if (DeliverState.currentField === "destination"&&DeliverState.destination) {
      handelReloadOnSaveMap(DeliverState.destination)
    } else if (DeliverState.currentField === "destination2"&&DeliverState.destination2) {
      handelReloadOnSaveMap(DeliverState.destination2)
    }else{
      dispatch({ type: "SET_MARKER_END", payload: [] });
      dispatch({ type: "SET_ZOOM", payload: [13] })
    }
  },[DeliverState.currentField,DeliverState.showModal,DeliverState.destination2,DeliverState.destination,DeliverState.origin])
  const handelReloadOnSaveMap=(mapData)=>{
    const marker = (
      <Mapir.Marker
        coordinates={mapData.location}
        Image={`/Assets/Images/map/${DeliverState.currentField === "origin" ? "originMarker.png" : DeliverState.currentField === "destination" ? "destenation.png" : "destenation2.png"}`}
        key={Date.now()}
      />
    );

    dispatch({ type: "SET_SELECTED_LOCATION", payload: mapData.location });
    dispatch({ type: "SET_MARKER_END", payload: marker });
    dispatch({ type: "SET_CENTER", payload: mapData.location });
    dispatch({
      type: "SET_ADDRESS_COMPACT",
      payload: mapData.address,
    });
  }

  // Memoize the Mapir token configuration
  const mapirConfig = useMemo(
    () =>
      Mapir.setToken({
        transformRequest: (url) => ({
          url: url,
          headers: {
            "x-api-key":
              "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImE1ODNiNzIzMWNjNTcxNzg4OGI2NzZkODI1NjNjM2RjNGQyNDJlMGVlZmQ3ZDcyZmYxYTZmN2E5ZDhjNmI3YTNhOWIxOTE1ZTdkOTQ5MDE1In0.eyJhdWQiOiIxNTE2OCIsImp0aSI6ImE1ODNiNzIzMWNjNTcxNzg4OGI2NzZkODI1NjNjM2RjNGQyNDJlMGVlZmQ3ZDcyZmYxYTZmN2E5ZDhjNmI3YTNhOWIxOTE1ZTdkOTQ5MDE1IiwiaWF0IjoxNjg3NjA2MzI2LCJuYmYiOjE2ODc2MDYzMjYsImV4cCI6MTY4OTA3NTEyNiwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.oSSkLtV_ZrBPiOLVVRjgAdbmtIKaA03H4zigvRXvnePLmkPd1oBQA4M4k4a68-JB3HtQmcOiXGSB0g_btjL6eArzq6f5g6tjAi0Hr7UV_AyCZXNDEcD1-ZnswznydpHsAiVNtmHD81PloLw6OV_WfQLqZXkE__jVttwk6Pi_8i7G6xEuenJ5GQxxwsyIBxdGvdXu-S85M0ULxcCWaaq1q-fKL9LfqyzxUz-whl_4SgqQHbxrypvuZ3Gi8zv9TYVy0GQx55Rw0rGXnxouQc-xAuWZFMJZ8xMxTPj-Nj4EYoanBvl4oKAqHANbMi-hZq9G-MBlI6bfLE05uN37XAInCA",
          },
        }),
      }),
    []
  );

  // Stable click handler
  const handleMapClick = useCallback((map, e) => {
    const selectedCoords = [e.lngLat.lng, e.lngLat.lat];
    dispatch({ type: "SET_SELECTED_LOCATION", payload: selectedCoords });

    const marker = (
      <Mapir.Marker
        coordinates={selectedCoords}
        Image={`/Assets/Images/map/${DeliverState.currentField === "origin" ? "originMarker.png" : DeliverState.currentField === "destination" ? "destenation.png" : "destenation2.png"}`}
        key={Date.now()}
      />
    );
    dispatch({ type: "SET_MARKER_END", payload: marker });
    dispatch({ type: "SET_CENTER", payload: selectedCoords });
    setTimeout(() => dispatch({ type: "SET_ZOOM", payload: [15] }), 500);
    fetchLocationInfo(selectedCoords);
  }, []);
  const fetchLocationInfo = (selectedCoords) => {
    fetch(
      `https://map.ir/reverse/no?lat=${selectedCoords[1]}&lon=${selectedCoords[0]}`,
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key":
            "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImE1ODNiNzIzMWNjNTcxNzg4OGI2NzZkODI1NjNjM2RjNGQyNDJlMGVlZmQ3ZDcyZmYxYTZmN2E5ZDhjNmI3YTNhOWIxOTE1ZTdkOTQ5MDE1In0.eyJhdWQiOiIxNTE2OCIsImp0aSI6ImE1ODNiNzIzMWNjNTcxNzg4OGI2NzZkODI1NjNjM2RjNGQyNDJlMGVlZmQ3ZDcyZmYxYTZmN2E5ZDhjNmI3YTNhOWIxOTE1ZTdkOTQ5MDE1IiwiaWF0IjoxNjg3NjA2MzI2LCJuYmYiOjE2ODc2MDYzMjYsImV4cCI6MTY4OTA3NTEyNiwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.oSSkLtV_ZrBPiOLVVRjgAdbmtIKaA03H4zigvRXvnePLmkPd1oBQA4M4k4a68-JB3HtQmcOiXGSB0g_btjL6eArzq6f5g6tjAi0Hr7UV_AyCZXNDEcD1-ZnswznydpHsAiVNtmHD81PloLw6OV_WfQLqZXkE__jVttwk6Pi_8i7G6xEuenJ5GQxxwsyIBxdGvdXu-S85M0ULxcCWaaq1q-fKL9LfqyzxUz-whl_4SgqQHbxrypvuZ3Gi8zv9TYVy0GQx55Rw0rGXnxouQc-xAuWZFMJZ8xMxTPj-Nj4EYoanBvl4oKAqHANbMi-hZq9G-MBlI6bfLE05uN37XAInCA",
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        dispatch({
          type: "SET_ADDRESS_COMPACT",
          payload: data.address_compact,
        });
      })
      .catch(console.error);
  };

  // Stable location handler
  const handleCurrentLocation = useCallback(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          dispatch({ type: "SET_CENTER", payload: [longitude, latitude] });
          dispatch({
            type: "SET_SELECTED_LOCATION",
            payload: [longitude, latitude],
          });

          const marker = (
            <Mapir.Marker
              coordinates={[longitude, latitude]}
              Image={`/Assets/Images/map/${DeliverState.currentField === "origin" ? "originMarker.png" : DeliverState.currentField === "destination" ? "destenation.png" : "destenation2.png"}`}
              key={Date.now()}
            />
          );
          dispatch({ type: "SET_MARKER_END", payload: marker });
          setTimeout(() => dispatch({ type: "SET_ZOOM", payload: [15] }), 1500);
          fetchLocationInfo([longitude, latitude]);
        },
        (error) => {
          console.error("Error fetching location:", error);
          alert("در مکان یابی شما مشکلی پیش آمده!");
        }
      );
    } else {
      errorToast("مرورگر شما این قابلیت را پشتیبانی نمی کند!");
    }
  }, []);

  // Stable search handler
  const handleSearchChange = useCallback((e) => {
    const query = e.target.value;
    dispatch({ type: "SET_SEARCH_QUERY", payload: query });

    if (!query) {
      dispatch({ type: "SET_SUGGESTIONS", payload: [] });
      return;
    }

    const payload = {
      $filter: "polygon eq true",
      $select: "poi,city,roads,neighborhood",
      polygon: {
        type: "Polygon",
        coordinates: [
          [
            [53.4949, 36.689295],
            [53.52434, 36.705901],
            [53.567101, 36.708051],
            [53.602236, 36.692963],
            [53.549487, 36.675879],
          ],
        ],
      },
      text: query,
    };

    fetch("https://map.ir/search/v2/autocomplete/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key":
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImE1ODNiNzIzMWNjNTcxNzg4OGI2NzZkODI1NjNjM2RjNGQyNDJlMGVlZmQ3ZDcyZmYxYTZmN2E5ZDhjNmI3YTNhOWIxOTE1ZTdkOTQ5MDE1In0.eyJhdWQiOiIxNTE2OCIsImp0aSI6ImE1ODNiNzIzMWNjNTcxNzg4OGI2NzZkODI1NjNjM2RjNGQyNDJlMGVlZmQ3ZDcyZmYxYTZmN2E5ZDhjNmI3YTNhOWIxOTE1ZTdkOTQ5MDE1IiwiaWF0IjoxNjg3NjA2MzI2LCJuYmYiOjE2ODc2MDYzMjYsImV4cCI6MTY4OTA3NTEyNiwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.oSSkLtV_ZrBPiOLVVRjgAdbmtIKaA03H4zigvRXvnePLmkPd1oBQA4M4k4a68-JB3HtQmcOiXGSB0g_btjL6eArzq6f5g6tjAi0Hr7UV_AyCZXNDEcD1-ZnswznydpHsAiVNtmHD81PloLw6OV_WfQLqZXkE__jVttwk6Pi_8i7G6xEuenJ5GQxxwsyIBxdGvdXu-S85M0ULxcCWaaq1q-fKL9LfqyzxUz-whl_4SgqQHbxrypvuZ3Gi8zv9TYVy0GQx55Rw0rGXnxouQc-xAuWZFMJZ8xMxTPj-Nj4EYoanBvl4oKAqHANbMi-hZq9G-MBlI6bfLE05uN37XAInCA",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) =>
        dispatch({ type: "SET_SUGGESTIONS", payload: data.value || [] })
      )
      .catch((error) => console.error("Error fetching suggestions:", error));
  }, []);

  // Stable suggestion click handler
  const handleSuggestionClick = useCallback((suggestion) => {
    dispatch({ type: "SET_CENTER", payload: suggestion.geom.coordinates });
    dispatch({
      type: "SET_SELECTED_LOCATION",
      payload: suggestion.geom.coordinates,
    });

    const marker = (
      <Mapir.Marker
        coordinates={suggestion.geom.coordinates}
        Image={`/Assets/Images/map/${DeliverState.currentField === "origin" ? "originMarker.png" : DeliverState.currentField === "destination" ? "destenation.png" : "destenation2.png"}`}
        key={Date.now()}
      />
    );
    dispatch({ type: "SET_MARKER_END", payload: marker });

    dispatch({ type: "SET_ZOOM", payload: [16] });
    fetchLocationInfo(suggestion.geom.coordinates);
    dispatch({ type: "RESET_SEARCH" });
  }, []);

  // Stable confirm handler
  const onclickConfirmAddress = useCallback(() => {
    if (!state.selectedLocation) {
      errorToast("لطفا یک نقطه را روی نقشه انتخاب کنید!");
      return;
    }

    const locationInfo = {
      location: state.selectedLocation,
      address: state.addressCompactState,
    };
    if (DeliverState.currentField === "origin") {
      onSelectLocation(locationInfo);
    } else if (DeliverState.currentField === "destination") {
      onSelectLocation(locationInfo);
    } else if (DeliverState.currentField === "destination2") {
      onSelectLocation(locationInfo);
    }
    closeModal();
  }, [
    state.selectedLocation,
    state.addressCompactState,
    onSelectLocation,
    closeModal,
    DeliverState.currentField,
  ]);

  return (
    <Modal
      open={DeliverState.showModal}
      onCancel={closeModal}
      width="100%"
      style={{ top: "0" }}
      bodyStyle={{ height: "92vh", padding: "12px" }}
      destroyOnClose
      footer={null}
    >
      <div className={Style.MapModal}>
        <Mapir
          key={`mapir-${state.mapKey}`}
          center={state.center}
          zoom={state.zoom}
          onClick={handleMapClick}
          Map={mapirConfig}
        >
          {state.markerEnd}
        </Mapir>

        <button
          className="current-location-btn"
          onClick={handleCurrentLocation}
        >
          📍
        </button>

        <div className={Style.bottomPart}>
          <div className={Style.searchContainer}>
            <input
              type="text"
              className={Style.searchInput}
              placeholder="جستجو..."
              value={state.searchQuery}
              onChange={handleSearchChange}
            />
            {state.suggestions?.length > 0 && (
              <ul className={Style.suggestions}>
                {state.suggestions.map((item, index) => (
                  <li
                    key={index}
                    className={Style.suggestionItem}
                    onClick={() => handleSuggestionClick(item)}
                  >
                    {item.title}
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div className={Style.aim}>
            <button
              onClick={onclickConfirmAddress}
              className={Style.setAddress}
            >
              تایید
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default React.memo(MapModal);
